/**
 * Shared constants across all platforms (Native, Web, etc.)
 */

/**
 * The identifier used for local data created when in Visitor Mode (unauthenticated).
 */
export const VISITOR_ID = "visitor";

/**
 * Standard HTTP Status Codes
 */
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;

/**
 * The slug for the default "Inbox" list.
 */
export const INBOX_SLUG = "inbox";

/**
 * A stable reference for an empty array to prevent unnecessary re-renders in hooks.
 */
export const EMPTY_ARRAY: readonly never[] = Object.freeze([]);

/**
 * SOFT_DELETE_STANDARD — trash retention: soft-deleted items
 * (wallet/category/tx) are physically purged after this number of days (server
 * job `TRASH_PURGE_DAYS`, with `0` = disabled). Trash UI uses it
 * for the countdown "will be permanently deleted in N days".
 */
export const TRASH_PURGE_DAYS = 30;

/**
 * Deep Linking Configuration
 */
export const APP_SCHEME = "cashsync";
export const APP_DOMAIN = "app.cashsync.com";
